const aboutTranslations = {
  en: {
    title: "What is Vision AI Stream?",
    description1: "Vision AI Stream is an advanced video editing platform based on artificial intelligence...",
    mainFeaturesTitle: "Main Features",
    transcription: "Automatic Transcription:",
    transcriptionDetail: "Converts audio to text with precision.",
    dubbingAI: "AI Dubbing:",
    dubbingAIDetail: "Translation and voiceover in multiple languages.",
    intelligentCut: "Intelligent Cut:",
    intelligentCutDetail: "Separates and rearranges segments automatically.",
    lipSync: "Lip Sync:",
    lipSyncDetail: "Adjusts lips to the new audio.",
    lipEnhance: "Lip Enhance:",
    lipEnhanceDetail: "Improves the precision of lip movements for a more natural dubbing.",
    videoMerge: "Video Merge:",
    videoMergeDetail: "Combines multiple processed clips.",
    realTimeProcess: "Real-Time Processing:",
    realTimeProcessDetail: "Quick editing and adjustments.",
    plansTitle: "Plans and Pricing",
    choosePlan: "Choose the ideal plan for you:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB and 30s limit. One-time trial with ads and watermark.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5GB/month, 2 videos/day (100MB), cut and merge tools.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20GB/month, 5 videos/day (500MB), voice cloning and lip sync.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50GB/month, 10 videos/day (1GB), lip enhance and priority support.",
    seeInAction: "See it in action!",
    officialChannel: "For more videos, visit our official channel:",
    officialChannelLink: "Vision AI Stream on YouTube",
    faqTitle: "Frequently Asked Questions (FAQ)",
    faqQuestion1: "Is Vision AI Stream free?",
    faqAnswer1: "Yes, we offer a one-time free trial. Paid plans provide more features.",
    faqQuestion2: "Which video formats are supported?",
    faqAnswer2: "We support popular formats such as MP4, AVI, and MOV.",
    faqQuestion3: "Can I use dubbing with voice cloning?",
    faqAnswer3: "Yes, starting from the Growth plan, you can use voice cloning and lip sync.",
    userFeedbackTitle: "User Feedback",
    userFeedbackDetail: "Vision AI Stream has a feedback form integrated into video processing, allowing users to submit suggestions and report issues directly.",
    backHomeButton: "Try it now 🚀",
    aboutCompanyTitle: "About the Company",
    companyDescription: "Vision AI Stream is developed by QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA, a company specialized in custom software development."
  },

  pt: {
    title: "O que é o Vision AI Stream?",
    description1: "O Vision AI Stream é uma plataforma avançada de edição de vídeos baseada em inteligência artificial...",
    mainFeaturesTitle: "Principais funcionalidades",
    transcription: "Transcrição Automática:",
    transcriptionDetail: "Converte áudio em texto com precisão.",
    dubbingAI: "Dublagem com IA:",
    dubbingAIDetail: "Tradução e locução em múltiplos idiomas.",
    intelligentCut: "Corte Inteligente:",
    intelligentCutDetail: "Separa e reorganiza trechos automaticamente.",
    lipSync: "Sincronização Labial:",
    lipSyncDetail: "Ajusta os lábios ao novo áudio.",
    lipEnhance: "Realce de Lábios:",
    lipEnhanceDetail: "Melhora a precisão dos movimentos labiais para tornar a dublagem ainda mais natural.",
    videoMerge: "Unificação de Vídeos:",
    videoMergeDetail: "Junta múltiplos trechos processados.",
    realTimeProcess: "Processamento em Tempo Real:",
    realTimeProcessDetail: "Edição e ajustes rápidos.",
    plansTitle: "Planos e Preços",
    choosePlan: "Escolha o plano ideal para você:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB e 30s de limite. Teste único com anúncios e marca d'água.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5GB/mês, 2 vídeos/dia (100MB), ferramentas de corte e junção.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20GB/mês, 5 vídeos/dia (500MB), voz clonada e sincronização labial.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50GB/mês, 10 vídeos/dia (1GB), realce de lábios e suporte prioritário.",
    seeInAction: "Veja na prática!",
    officialChannel: "Para mais vídeos, acesse nosso canal oficial:",
    officialChannelLink: "Vision AI Stream no YouTube",
    faqTitle: "Perguntas Frequentes (FAQ)",
    faqQuestion1: "O Vision AI Stream é gratuito?",
    faqAnswer1: "Sim, oferecemos um teste gratuito único. Os planos pagos oferecem mais recursos.",
    faqQuestion2: "Quais formatos de vídeo são suportados?",
    faqAnswer2: "Os formatos suportados incluem MP4, AVI e MOV.",
    faqQuestion3: "Posso usar a dublagem com voz clonada?",
    faqAnswer3: "Sim, a partir do plano Growth, você pode utilizar a dublagem com voz clonada e sincronização labial.",
    userFeedbackTitle: "Feedback dos Usuários",
    userFeedbackDetail: "O Vision AI Stream conta com um formulário de feedback integrado no processamento de vídeos, permitindo que os usuários enviem sugestões e relatem problemas diretamente.",
    backHomeButton: "Experimente agora 🚀",
    aboutCompanyTitle: "Sobre a Empresa",
    companyDescription: "O Vision AI Stream é desenvolvido pela QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA, especializada em desenvolvimento de software sob encomenda."
  },

  es: {
    title: "¿Qué es Vision AI Stream?",
    description1: "Vision AI Stream es una plataforma avanzada de edición de video basada en inteligencia artificial...",
    mainFeaturesTitle: "Principales Funciones",
    transcription: "Transcripción Automática:",
    transcriptionDetail: "Convierte el audio en texto con precisión.",
    dubbingAI: "Doblaje con IA:",
    dubbingAIDetail: "Traducción y locución en múltiples idiomas.",
    intelligentCut: "Corte Inteligente:",
    intelligentCutDetail: "Separa y reorganiza segmentos automáticamente.",
    lipSync: "Sincronización Labial:",
    lipSyncDetail: "Ajusta los labios al nuevo audio.",
    lipEnhance: "Realce de Labios:",
    lipEnhanceDetail: "Mejora la precisión de los movimientos labiales para un doblaje más natural.",
    videoMerge: "Unión de Videos:",
    videoMergeDetail: "Une varios segmentos procesados.",
    realTimeProcess: "Procesamiento en Tiempo Real:",
    realTimeProcessDetail: "Edición y ajustes rápidos.",
    plansTitle: "Planes y Precios",
    choosePlan: "Elige el plan ideal para ti:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB y 30s de límite. Prueba única con anuncios y marca de agua.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5GB/mes, 2 videos/día (100MB), herramientas de corte y unión.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20GB/mes, 5 videos/día (500MB), clonación de voz y sincronización labial.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50GB/mes, 10 videos/día (1GB), realce de labios y soporte prioritario.",
    seeInAction: "¡Míralo en acción!",
    officialChannel: "Para más videos, visita nuestro canal oficial:",
    officialChannelLink: "Vision AI Stream en YouTube",
    faqTitle: "Preguntas Frecuentes (FAQ)",
    faqQuestion1: "¿Es Vision AI Stream gratuito?",
    faqAnswer1: "Sí, ofrecemos una prueba gratuita única. Los planes de pago ofrecen más funciones.",
    faqQuestion2: "¿Qué formatos de video se admiten?",
    faqAnswer2: "Soportamos MP4, AVI y MOV.",
    faqQuestion3: "¿Puedo usar doblaje con clonación de voz?",
    faqAnswer3: "Sí, a partir del plan Growth puedes usar clonación de voz y sincronización labial.",
    userFeedbackTitle: "Comentarios de los Usuarios",
    userFeedbackDetail: "Vision AI Stream cuenta con un formulario de retroalimentación integrado, permitiendo a los usuarios enviar sugerencias y reportar problemas directamente.",
    backHomeButton: "Pruébalo ahora 🚀",
    aboutCompanyTitle: "Sobre la Empresa",
    companyDescription: "Vision AI Stream es desarrollado por QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA, especializada en desarrollo de software a medida."
  },

  fr: {
    title: "Qu’est-ce que Vision AI Stream ?",
    description1: "Vision AI Stream est une plateforme avancée d’édition vidéo basée sur l’intelligence artificielle...",
    mainFeaturesTitle: "Fonctionnalités Principales",
    transcription: "Transcription Automatique :",
    transcriptionDetail: "Convertit l’audio en texte avec précision.",
    dubbingAI: "Doublage IA :",
    dubbingAIDetail: "Traduction et voix-off dans plusieurs langues.",
    intelligentCut: "Coupe Intelligente :",
    intelligentCutDetail: "Sépare et réorganise automatiquement les segments.",
    lipSync: "Synchronisation Labiale :",
    lipSyncDetail: "Ajuste les lèvres à l’audio nouvellement créé.",
    lipEnhance: "Rehaussement des Lèvres :",
    lipEnhanceDetail: "Améliore la précision des mouvements labiaux pour un doublage plus naturel.",
    videoMerge: "Fusion de Vidéos :",
    videoMergeDetail: "Combine plusieurs extraits traités.",
    realTimeProcess: "Traitement en Temps Réel :",
    realTimeProcessDetail: "Montage rapide et ajustements instantanés.",
    plansTitle: "Plans et Tarifs",
    choosePlan: "Choisissez le plan idéal pour vous :",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB et 30s de limite. Essai unique avec pub et filigrane.",
    visionStarter: "Vision Starter :",
    visionStarterDetail: "5 Go/mois, 2 vidéos/jour (100 Mo), outils de découpe et de fusion.",
    visionGrowth: "Vision Growth :",
    visionGrowthDetail: "20 Go/mois, 5 vidéos/jour (500 Mo), clonage de voix et synchronisation labiale.",
    visionPremium: "Vision Premium :",
    visionPremiumDetail: "50 Go/mois, 10 vidéos/jour (1 Go), rehaussement des lèvres et support prioritaire.",
    seeInAction: "Découvrez-le en action !",
    officialChannel: "Pour plus de vidéos, visitez notre chaîne officielle :",
    officialChannelLink: "Vision AI Stream sur YouTube",
    faqTitle: "Questions Fréquemment Posées (FAQ)",
    faqQuestion1: "Le Vision AI Stream est-il gratuit ?",
    faqAnswer1: "Oui, nous proposons un essai gratuit unique. Les plans payants offrent plus de fonctionnalités.",
    faqQuestion2: "Quels formats vidéo sont pris en charge ?",
    faqAnswer2: "Nous prenons en charge des formats populaires comme MP4, AVI et MOV.",
    faqQuestion3: "Puis-je utiliser le doublage avec clonage de voix ?",
    faqAnswer3: "Oui, à partir du plan Growth, vous pouvez utiliser le clonage de voix et la synchronisation labiale.",
    userFeedbackTitle: "Retour des Utilisateurs",
    userFeedbackDetail: "Vision AI Stream dispose d’un formulaire de feedback intégré au traitement vidéo, permettant aux utilisateurs d’envoyer des suggestions et de signaler des problèmes directement.",
    backHomeButton: "Essayez-le maintenant 🚀",
    aboutCompanyTitle: "À propos de l’Entreprise",
    companyDescription: "Vision AI Stream est développé par QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA, spécialisée dans le développement de logiciels sur mesure."
  },

  de: {
    title: "Was ist Vision AI Stream?",
    description1: "Vision AI Stream ist eine fortschrittliche Videobearbeitungsplattform, die auf künstlicher Intelligenz basiert...",
    mainFeaturesTitle: "Hauptfunktionen",
    transcription: "Automatische Transkription:",
    transcriptionDetail: "Wandelt Audio präzise in Text um.",
    dubbingAI: "KI-Synchronisierung:",
    dubbingAIDetail: "Übersetzung und Voiceover in mehreren Sprachen.",
    intelligentCut: "Intelligenter Schnitt:",
    intelligentCutDetail: "Teilt und sortiert Segmente automatisch neu.",
    lipSync: "Lippensynchronisation:",
    lipSyncDetail: "Passt die Lippen an das neue Audio an.",
    lipEnhance: "Lippenverbesserung:",
    lipEnhanceDetail: "Verbessert die Präzision der Lippenbewegungen für eine natürlichere Synchronisation.",
    videoMerge: "Videokombination:",
    videoMergeDetail: "Fasst mehrere bearbeitete Clips zusammen.",
    realTimeProcess: "Echtzeitverarbeitung:",
    realTimeProcessDetail: "Schnelle Bearbeitung und sofortige Anpassungen.",
    plansTitle: "Pläne und Preise",
    choosePlan: "Wählen Sie den idealen Plan für sich:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB und 30s Limit. Einmaliger Test mit Werbung und Wasserzeichen.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5 GB/Monat, 2 Videos/Tag (100 MB), Werkzeuge zum Schneiden und Zusammenfügen.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20 GB/Monat, 5 Videos/Tag (500 MB), Sprachklon und Lippensynchronisation.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50 GB/Monat, 10 Videos/Tag (1 GB), Lippenverbesserung und Prioritätssupport.",
    seeInAction: "Sehen Sie es in Aktion!",
    officialChannel: "Für weitere Videos besuchen Sie unseren offiziellen Kanal:",
    officialChannelLink: "Vision AI Stream auf YouTube",
    faqTitle: "Häufig gestellte Fragen (FAQ)",
    faqQuestion1: "Ist Vision AI Stream kostenlos?",
    faqAnswer1: "Ja, wir bieten eine einmalige kostenlose Testversion an. Bezahlte Pläne bieten mehr Funktionen.",
    faqQuestion2: "Welche Videoformate werden unterstützt?",
    faqAnswer2: "Wir unterstützen beliebte Formate wie MP4, AVI und MOV.",
    faqQuestion3: "Kann ich Synchronisation mit Sprachklon verwenden?",
    faqAnswer3: "Ja, ab dem Growth-Plan können Sie Sprachklon und Lippensynchronisation verwenden.",
    userFeedbackTitle: "Benutzerfeedback",
    userFeedbackDetail: "Vision AI Stream verfügt über ein integriertes Feedback-Formular im Videoprozess, sodass Benutzer direkt Vorschläge senden und Probleme melden können.",
    backHomeButton: "Jetzt ausprobieren 🚀",
    aboutCompanyTitle: "Über das Unternehmen",
    companyDescription: "Vision AI Stream wird von QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA entwickelt, spezialisiert auf kundenspezifische Softwareentwicklung."
  },

  it: {
    title: "Che cos’è Vision AI Stream?",
    description1: "Vision AI Stream è una piattaforma avanzata di editing video basata sull’intelligenza artificiale...",
    mainFeaturesTitle: "Funzionalità Principali",
    transcription: "Trascrizione Automatica:",
    transcriptionDetail: "Converte l’audio in testo con precisione.",
    dubbingAI: "Doppiaggio con IA:",
    dubbingAIDetail: "Traduzione e voice-over in più lingue.",
    intelligentCut: "Taglio Intelligente:",
    intelligentCutDetail: "Separa e riorganizza automaticamente i segmenti.",
    lipSync: "Sincronizzazione Labiale:",
    lipSyncDetail: "Adatta i movimenti delle labbra al nuovo audio.",
    lipEnhance: "Realce delle Labbra:",
    lipEnhanceDetail: "Migliora la precisione dei movimenti labiali per un doppiaggio più naturale.",
    videoMerge: "Unione di Video:",
    videoMergeDetail: "Unisce più clip elaborate.",
    realTimeProcess: "Elaborazione in Tempo Reale:",
    realTimeProcessDetail: "Modifiche rapide e regolazioni immediate.",
    plansTitle: "Piani e Prezzi",
    choosePlan: "Scegli il piano ideale per te:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB e 30s di limite. Prova unica con annunci e filigrana.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5 GB/mese, 2 video/giorno (100 MB), strumenti di taglio e unione.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20 GB/mese, 5 video/giorno (500 MB), clonazione vocale e sincronizzazione labiale.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50 GB/mese, 10 video/giorno (1 GB), realce delle labbra e supporto prioritario.",
    seeInAction: "Guardalo in azione!",
    officialChannel: "Per ulteriori video, visita il nostro canale ufficiale:",
    officialChannelLink: "Vision AI Stream su YouTube",
    faqTitle: "Domande Frequenti (FAQ)",
    faqQuestion1: "Vision AI Stream è gratuito?",
    faqAnswer1: "Sì, offriamo una prova gratuita unica. I piani a pagamento offrono più funzionalità.",
    faqQuestion2: "Quali formati video sono supportati?",
    faqAnswer2: "Supportiamo formati popolari come MP4, AVI e MOV.",
    faqQuestion3: "Posso usare il doppiaggio con clonazione vocale?",
    faqAnswer3: "Sì, a partire dal piano Growth, puoi utilizzare la clonazione vocale e la sincronizzazione labiale.",
    userFeedbackTitle: "Feedback degli Utenti",
    userFeedbackDetail: "Vision AI Stream dispone di un modulo di feedback integrato durante l’elaborazione dei video, permettendo agli utenti di inviare suggerimenti e segnalare problemi direttamente.",
    backHomeButton: "Provalo ora 🚀",
    aboutCompanyTitle: "Informazioni sull’Azienda",
    companyDescription: "Vision AI Stream è sviluppato da QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA, specializzata nello sviluppo di software su misura."
  },

  ru: {
    title: "Что такое Vision AI Stream?",
    description1: "Vision AI Stream — это продвинутая платформа для редактирования видео, основанная на искусственном интеллекте...",
    mainFeaturesTitle: "Основные функции",
    transcription: "Автоматическая транскрипция:",
    transcriptionDetail: "Точно преобразует аудио в текст.",
    dubbingAI: "ИИ-Дублирование:",
    dubbingAIDetail: "Перевод и озвучка на нескольких языках.",
    intelligentCut: "Интеллектуальный разрез:",
    intelligentCutDetail: "Автоматически разделяет и перестраивает фрагменты.",
    lipSync: "Синхронизация губ:",
    lipSyncDetail: "Настраивает движения губ под новый аудио.",
    lipEnhance: "Усиление губ:",
    lipEnhanceDetail: "Улучшает точность движений губ для более естественной озвучки.",
    videoMerge: "Объединение видео:",
    videoMergeDetail: "Объединяет несколько обработанных клипов.",
    realTimeProcess: "Обработка в реальном времени:",
    realTimeProcessDetail: "Быстрое редактирование и мгновенные корректировки.",
    plansTitle: "Планы и цены",
    choosePlan: "Выберите идеальный план для себя:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB и 30с ограничение. Один тест с рекламой и водяным знаком.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5 ГБ/месяц, 2 видео в день (100 МБ), инструменты для нарезки и склейки.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20 ГБ/месяц, 5 видео в день (500 МБ), клон голоса и синхронизация губ.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50 ГБ/месяц, 10 видео в день (1 ГБ), усиление губ и приоритетная поддержка.",
    seeInAction: "Посмотрите в действии!",
    officialChannel: "Для большего количества видео посетите наш официальный канал:",
    officialChannelLink: "Vision AI Stream на YouTube",
    faqTitle: "Часто задаваемые вопросы (FAQ)",
    faqQuestion1: "Vision AI Stream бесплатен?",
    faqAnswer1: "Да, мы предлагаем разовую бесплатную пробную версию. Платные планы предоставляют больше функций.",
    faqQuestion2: "Какие видеоформаты поддерживаются?",
    faqAnswer2: "Мы поддерживаем популярные форматы, такие как MP4, AVI и MOV.",
    faqQuestion3: "Могу ли я использовать дублирование с клонированием голоса?",
    faqAnswer3: "Да, начиная с плана Growth, вы можете использовать клон голоса и синхронизацию губ.",
    userFeedbackTitle: "Отзывы пользователей",
    userFeedbackDetail: "В Vision AI Stream есть встроенная форма обратной связи в процессе обработки видео, позволяющая пользователям напрямую отправлять предложения и сообщать о проблемах.",
    backHomeButton: "Попробовать сейчас 🚀",
    aboutCompanyTitle: "О компании",
    companyDescription: "Vision AI Stream разработан QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA, специализированной в разработке программного обеспечения на заказ."
  },

  zh: {
    title: "什么是 Vision AI Stream？",
    description1: "Vision AI Stream 是一个基于人工智能的高级视频编辑平台...",
    mainFeaturesTitle: "主要功能",
    transcription: "自动转录：",
    transcriptionDetail: "精准地将音频转换为文本。",
    dubbingAI: "AI 配音：",
    dubbingAIDetail: "可在多种语言中进行翻译和配音。",
    intelligentCut: "智能剪辑：",
    intelligentCutDetail: "自动分割并重新排列片段。",
    lipSync: "唇同步：",
    lipSyncDetail: "将嘴唇与新的音频进行匹配。",
    lipEnhance: "唇部增强：",
    lipEnhanceDetail: "提高口型动作的精准度，使配音更加自然。",
    videoMerge: "视频合并：",
    videoMergeDetail: "合并多个处理过的视频片段。",
    realTimeProcess: "实时处理：",
    realTimeProcessDetail: "快速编辑并进行即时调整。",
    plansTitle: "套餐和价格",
    choosePlan: "选择适合您的方案：",
    visionFree: "Vision Free",
    visionFreeDetail: "50MB 和 30 秒限制。一次性试用，含广告和水印。",
    visionStarter: "Vision Starter：",
    visionStarterDetail: "每月5GB，每天2个视频（100MB），包含剪切和合并工具。",
    visionGrowth: "Vision Growth：",
    visionGrowthDetail: "每月20GB，每天5个视频（500MB），提供语音克隆和唇同步。",
    visionPremium: "Vision Premium：",
    visionPremiumDetail: "每月50GB，每天10个视频（1GB），提供唇部增强和优先支持。",
    seeInAction: "观看演示！",
    officialChannel: "查看更多视频，请访问我们的官方频道：",
    officialChannelLink: "Vision AI Stream 在 YouTube 上",
    faqTitle: "常见问题（FAQ）",
    faqQuestion1: "Vision AI Stream 是免费的吗？",
    faqAnswer1: "是的，我们提供一次性免费试用。付费计划提供更多功能。",
    faqQuestion2: "支持哪些视频格式？",
    faqAnswer2: "我们支持 MP4、AVI、MOV 等流行格式。",
    faqQuestion3: "我可以使用语音克隆的配音吗？",
    faqAnswer3: "可以，从 Growth 套餐开始，您可以使用语音克隆和唇同步功能。",
    userFeedbackTitle: "用户反馈",
    userFeedbackDetail: "Vision AI Stream 在视频处理过程中集成了反馈表单，允许用户直接提交建议并报告问题。",
    backHomeButton: "立即试用 🚀",
    aboutCompanyTitle: "关于我们",
    companyDescription: "Vision AI Stream 由 QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA 开发，专门从事定制软件开发。"
  },

  ja: {
    title: "Vision AI Streamとは？",
    description1: "Vision AI Streamは、人工知能をベースにした高度な動画編集プラットフォームです…",
    mainFeaturesTitle: "主な機能",
    transcription: "自動文字起こし：",
    transcriptionDetail: "音声を正確にテキスト化します。",
    dubbingAI: "AI吹き替え：",
    dubbingAIDetail: "複数言語での翻訳とナレーション。",
    intelligentCut: "インテリジェントカット：",
    intelligentCutDetail: "映像を自動的に分割し再配置します。",
    lipSync: "リップシンク：",
    lipSyncDetail: "新しい音声に合わせて口の動きを調整します。",
    lipEnhance: "リップエンハンス：",
    lipEnhanceDetail: "唇の動きの精度を高め、より自然な吹き替えを実現します。",
    videoMerge: "動画結合：",
    videoMergeDetail: "処理済みの複数クリップを統合します。",
    realTimeProcess: "リアルタイム処理：",
    realTimeProcessDetail: "素早い編集と即時調整が可能です。",
    plansTitle: "プランと料金",
    choosePlan: "あなたに最適なプランをお選びください：",
    visionFree: "Vision Free",
    visionFreeDetail: "50MB・30秒の制限。広告・透かし付きの一度限りの試用。",
    visionStarter: "Vision Starter：",
    visionStarterDetail: "月間5GB、1日2本の動画（100MB）、カット＆結合ツール付き。",
    visionGrowth: "Vision Growth：",
    visionGrowthDetail: "月間20GB、1日5本の動画（500MB）、ボイスクローンとリップシンク機能を搭載。",
    visionPremium: "Vision Premium：",
    visionPremiumDetail: "月間50GB、1日10本の動画（1GB）、リップエンハンスと優先サポート付き。",
    seeInAction: "実際の動作をチェック！",
    officialChannel: "さらに動画を見るには、公式チャンネルをチェック：",
    officialChannelLink: "YouTube上のVision AI Stream",
    faqTitle: "よくある質問（FAQ）",
    faqQuestion1: "Vision AI Streamは無料ですか？",
    faqAnswer1: "はい、一度限りの無料トライアルをご提供しています。有料プランではさらに多くの機能を利用できます。",
    faqQuestion2: "どの動画形式がサポートされていますか？",
    faqAnswer2: "MP4、AVI、MOVなどの一般的な形式に対応しています。",
    faqQuestion3: "ボイスクローンでの吹き替えは可能ですか？",
    faqAnswer3: "はい、Growthプランからボイスクローンとリップシンクを使用できます。",
    userFeedbackTitle: "ユーザーフィードバック",
    userFeedbackDetail: "Vision AI Streamには、動画処理中にフィードバックフォームが統合されており、ユーザーが直接提案や問題を報告できます。",
    backHomeButton: "今すぐ試す 🚀",
    aboutCompanyTitle: "会社概要",
    companyDescription: "Vision AI Streamは、カスタムソフトウェア開発を専門とするQUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDAによって開発されています。"
  },

  ko: {
    title: "Vision AI Stream이란?",
    description1: "Vision AI Stream은 인공 지능을 기반으로 한 고급 동영상 편집 플랫폼입니다...",
    mainFeaturesTitle: "주요 기능",
    transcription: "자동 전사:",
    transcriptionDetail: "오디오를 정확하게 텍스트로 변환합니다.",
    dubbingAI: "AI 더빙:",
    dubbingAIDetail: "여러 언어로 번역 및 보이스오버를 제공합니다.",
    intelligentCut: "지능형 컷:",
    intelligentCutDetail: "세그먼트를 자동으로 분리하고 재배치합니다.",
    lipSync: "립싱크:",
    lipSyncDetail: "새 오디오에 맞춰 입술 움직임을 조정합니다.",
    lipEnhance: "립 강화:",
    lipEnhanceDetail: "입술 움직임의 정밀도를 높여 더욱 자연스러운 더빙을 구현합니다.",
    videoMerge: "비디오 병합:",
    videoMergeDetail: "처리된 여러 클립을 결합합니다.",
    realTimeProcess: "실시간 처리:",
    realTimeProcessDetail: "빠른 편집과 즉각적인 조정이 가능합니다.",
    plansTitle: "플랜 및 가격",
    choosePlan: "사용자에게 맞는 플랜을 선택하세요:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB 및 30초 제한. 광고와 워터마크 포함 1회 체험.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "월 5GB, 하루 2개 동영상(100MB), 자르기와 병합 도구 제공.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "월 20GB, 하루 5개 동영상(500MB), 음성 클론 및 립싱크.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "월 50GB, 하루 10개 동영상(1GB), 립 강화 및 우선 지원.",
    seeInAction: "실제로 확인해보세요!",
    officialChannel: "더 많은 동영상을 보려면 공식 채널을 방문하세요:",
    officialChannelLink: "YouTube의 Vision AI Stream",
    faqTitle: "자주 묻는 질문(FAQ)",
    faqQuestion1: "Vision AI Stream은 무료인가요?",
    faqAnswer1: "네, 1회 무료 체험을 제공합니다. 유료 플랜은 더 많은 기능을 제공합니다.",
    faqQuestion2: "어떤 동영상 포맷을 지원하나요?",
    faqAnswer2: "MP4, AVI, MOV 등의 일반적인 형식을 지원합니다.",
    faqQuestion3: "음성 클론을 사용한 더빙이 가능한가요?",
    faqAnswer3: "네, Growth 플랜부터 음성 클론과 립싱크를 사용할 수 있습니다.",
    userFeedbackTitle: "사용자 피드백",
    userFeedbackDetail: "Vision AI Stream은 동영상 처리 중에 통합된 피드백 양식을 제공하여 사용자가 직접 제안 및 문제를 보고할 수 있습니다.",
    backHomeButton: "지금 시도하기 🚀",
    aboutCompanyTitle: "회사 정보",
    companyDescription: "Vision AI Stream은 맞춤형 소프트웨어 개발을 전문으로 하는 QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA에서 개발되었습니다."
  },

  hi: {
    title: "Vision AI Stream क्या है?",
    description1: "Vision AI Stream एक उन्नत वीडियो संपादन प्लेटफ़ॉर्म है, जो कृत्रिम बुद्धिमत्ता पर आधारित है...",
    mainFeaturesTitle: "मुख्य विशेषताएँ",
    transcription: "स्वचालित ट्रांसक्रिप्शन:",
    transcriptionDetail: "ऑडियो को सटीकता से टेक्स्ट में परिवर्तित करता है।",
    dubbingAI: "AI डबिंग:",
    dubbingAIDetail: "कई भाषाओं में अनुवाद और वॉयसओवर करता है।",
    intelligentCut: "इंटेलिजेंट कट:",
    intelligentCutDetail: "सेगमेंट को स्वचालित रूप से विभाजित और पुनर्व्यवस्थित करता है।",
    lipSync: "लिप सिंक:",
    lipSyncDetail: "नए ऑडियो के अनुरूप होंठों की गतिविधियों को समायोजित करता है।",
    lipEnhance: "लिप एनहांस:",
    lipEnhanceDetail: "होंठ की गति की सटीकता में सुधार करके डबिंग को और अधिक स्वाभाविक बनाता है।",
    videoMerge: "वीडियो एकीकरण:",
    videoMergeDetail: "कई प्रसंस्कृत क्लिप को एकीकृत करता है।",
    realTimeProcess: "रियल-टाइम प्रोसेसिंग:",
    realTimeProcessDetail: "तेज़ संपादन और त्वरित समायोजन प्रदान करता है।",
    plansTitle: "योजनाएँ और मूल्य निर्धारण",
    choosePlan: "अपने लिए आदर्श योजना चुनें:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB और 30s की सीमा। एक बार का परीक्षण, विज्ञापन और वॉटरमार्क के साथ।",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5GB/माह, 2 वीडियो/दिन (100MB), कट और मर्ज टूल शामिल हैं।",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20GB/माह, 5 वीडियो/दिन (500MB), वॉइस क्लोन और लिप सिंक।",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50GB/माह, 10 वीडियो/दिन (1GB), लिप एनहांस और प्राथमिकता समर्थन।",
    seeInAction: "इसे क्रियान्वित होते हुए देखें!",
    officialChannel: "अधिक वीडियो के लिए, हमारे आधिकारिक चैनल पर जाएँ:",
    officialChannelLink: "YouTube पर Vision AI Stream",
    faqTitle: "अक्सर पूछे जाने वाले प्रश्न (FAQ)",
    faqQuestion1: "क्या Vision AI Stream निःशुल्क है?",
    faqAnswer1: "हाँ, हम एक बार का मुफ्त परीक्षण प्रदान करते हैं। सशुल्क योजनाएँ अधिक सुविधाएँ प्रदान करती हैं।",
    faqQuestion2: "कौन-कौन से वीडियो फ़ॉर्मैट समर्थित हैं?",
    faqAnswer2: "हम MP4, AVI और MOV जैसे लोकप्रिय फ़ॉर्मैट का समर्थन करते हैं।",
    faqQuestion3: "क्या मैं वॉइस क्लोन के साथ डबिंग का उपयोग कर सकता हूँ?",
    faqAnswer3: "हाँ, Growth योजना से आप वॉइस क्लोन और लिप सिंक का उपयोग कर सकते हैं।",
    userFeedbackTitle: "उपयोगकर्ता फीडबैक",
    userFeedbackDetail: "Vision AI Stream में वीडियो प्रसंस्करण के दौरान एक फीडबैक फ़ॉर्म एकीकृत है, जो उपयोगकर्ताओं को सीधे सुझाव देने और समस्याओं की रिपोर्ट करने की अनुमति देता है।",
    backHomeButton: "अभी आज़माएँ 🚀",
    aboutCompanyTitle: "कंपनी के बारे में",
    companyDescription: "Vision AI Stream को QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA द्वारा विकसित किया गया है, जो कस्टम सॉफ़्टवेयर विकास में विशेषज्ञता रखती है।"
  },

  ar: {
    title: "ما هو Vision AI Stream؟",
    description1: "Vision AI Stream عبارة عن منصة متقدمة لتحرير الفيديو تعتمد على الذكاء الاصطناعي...",
    mainFeaturesTitle: "الميزات الرئيسية",
    transcription: "النسخ التلقائي:",
    transcriptionDetail: "يقوم بتحويل الصوت إلى نص بدقة.",
    dubbingAI: "دبلجة بالذكاء الاصطناعي:",
    dubbingAIDetail: "الترجمة والتعليق الصوتي بعدة لغات.",
    intelligentCut: "القطع الذكي:",
    intelligentCutDetail: "يفصل ويعيد ترتيب المقاطع تلقائيًا.",
    lipSync: "مزامنة الشفاه:",
    lipSyncDetail: "يضبط حركة الشفاه مع الصوت الجديد.",
    lipEnhance: "تحسين الشفاه:",
    lipEnhanceDetail: "يعزز دقة حركات الشفاه لجعل الدبلجة أكثر طبيعية.",
    videoMerge: "دمج الفيديوهات:",
    videoMergeDetail: "يدمج عدة مقاطع تمت معالجتها.",
    realTimeProcess: "المعالجة في الوقت الفعلي:",
    realTimeProcessDetail: "تحرير سريع وضبط فوري.",
    plansTitle: "الخطط والأسعار",
    choosePlan: "اختر الخطة المثالية بالنسبة لك:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB و30 ثانية كحد أقصى. تجربة واحدة بإعلانات وعلامة مائية.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5 جيجابايت/شهر، فيديوهان/اليوم (100 ميجابايت)، أدوات قص ودمج.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20 جيجابايت/شهر، 5 فيديوهات/اليوم (500 ميجابايت)، استنساخ الصوت ومزامنة الشفاه.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50 جيجابايت/شهر، 10 فيديوهات/اليوم (1 جيجابايت)، تحسين الشفاه ودعم ذو أولوية.",
    seeInAction: "شاهدها في العمل!",
    officialChannel: "لمزيد من الفيديوهات، قم بزيارة قناتنا الرسمية:",
    officialChannelLink: "Vision AI Stream على YouTube",
    faqTitle: "الأسئلة الشائعة (FAQ)",
    faqQuestion1: "هل Vision AI Stream مجاني؟",
    faqAnswer1: "نعم، نحن نقدم تجربة مجانية لمرة واحدة. توفر الخطط المدفوعة المزيد من الميزات.",
    faqQuestion2: "ما هي تنسيقات الفيديو المدعومة؟",
    faqAnswer2: "نحن ندعم التنسيقات الشائعة مثل MP4 و AVI و MOV.",
    faqQuestion3: "هل يمكنني استخدام الدبلجة مع استنساخ الصوت؟",
    faqAnswer3: "نعم، بدءًا من خطة Growth يمكنك استخدام استنساخ الصوت ومزامنة الشفاه.",
    userFeedbackTitle: "تعليقات المستخدمين",
    userFeedbackDetail: "يتضمن Vision AI Stream نموذج ملاحظات مدمجًا في عملية معالجة الفيديو، مما يسمح للمستخدمين بتقديم الاقتراحات والإبلاغ عن المشكلات مباشرة.",
    backHomeButton: "جرّبها الآن 🚀",
    aboutCompanyTitle: "حول الشركة",
    companyDescription: "تم تطوير Vision AI Stream بواسطة QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA، المتخصصة في تطوير البرامج المخصصة."
  },

  tr: {
    title: "Vision AI Stream Nedir?",
    description1: "Vision AI Stream, yapay zekâ tabanlı gelişmiş bir video düzenleme platformudur...",
    mainFeaturesTitle: "Başlıca Özellikler",
    transcription: "Otomatik Transkripsiyon:",
    transcriptionDetail: "Sesi doğru bir şekilde metne dönüştürür.",
    dubbingAI: "Yapay Zekâ Dublaj:",
    dubbingAIDetail: "Birden fazla dilde çeviri ve seslendirme sağlar.",
    intelligentCut: "Akıllı Kesim:",
    intelligentCutDetail: "Segmentleri otomatik olarak ayırır ve yeniden düzenler.",
    lipSync: "Dudak Senkronizasyonu:",
    lipSyncDetail: "Yeni sesle dudak hareketlerini eşitler.",
    lipEnhance: "Dudak Geliştirme:",
    lipEnhanceDetail: "Dudak hareketlerinin hassasiyetini artırarak daha doğal dublaj sağlar.",
    videoMerge: "Video Birleştirme:",
    videoMergeDetail: "Birden fazla işlenmiş klibi birleştirir.",
    realTimeProcess: "Gerçek Zamanlı İşleme:",
    realTimeProcessDetail: "Hızlı düzenleme ve anında ayarlar.",
    plansTitle: "Planlar ve Fiyatlar",
    choosePlan: "Kendinize en uygun planı seçin:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB ve 30s sınırı. Reklamlı ve filigranlı tek seferlik deneme.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "Aylık 5GB, günde 2 video (100MB), kesme ve birleştirme araçları.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "Aylık 20GB, günde 5 video (500MB), ses klonu ve dudak senkronizasyonu.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "Aylık 50GB, günde 10 video (1GB), dudak geliştirme ve öncelikli destek.",
    seeInAction: "Nasıl çalıştığını görün!",
    officialChannel: "Daha fazla video için resmi kanalımızı ziyaret edin:",
    officialChannelLink: "YouTube'da Vision AI Stream",
    faqTitle: "Sıkça Sorulan Sorular (FAQ)",
    faqQuestion1: "Vision AI Stream ücretsiz mi?",
    faqAnswer1: "Evet, tek seferlik ücretsiz deneme sunuyoruz. Ücretli planlar daha fazla özellik sunar.",
    faqQuestion2: "Hangi video formatları destekleniyor?",
    faqAnswer2: "MP4, AVI ve MOV gibi popüler formatları destekliyoruz.",
    faqQuestion3: "Ses klonu ile dublaj kullanabilir miyim?",
    faqAnswer3: "Evet, Growth planından itibaren ses klonu ve dudak senkronizasyonu kullanabilirsiniz.",
    userFeedbackTitle: "Kullanıcı Geri Bildirimi",
    userFeedbackDetail: "Vision AI Stream, video işleme sürecinde bütünleşik bir geri bildirim formuna sahiptir ve kullanıcıların doğrudan öneri ve sorun bildirmesine olanak tanır.",
    backHomeButton: "Şimdi deneyin 🚀",
    aboutCompanyTitle: "Şirket Hakkında",
    companyDescription: "Vision AI Stream, özel yazılım geliştirme konusunda uzmanlaşmış QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA tarafından geliştirilmiştir."
  },

  nl: {
    title: "Wat is Vision AI Stream?",
    description1: "Vision AI Stream is een geavanceerd videobewerkingsplatform op basis van kunstmatige intelligentie...",
    mainFeaturesTitle: "Belangrijkste functies",
    transcription: "Automatische transcriptie:",
    transcriptionDetail: "Zet audio nauwkeurig om in tekst.",
    dubbingAI: "AI-nasynchronisatie:",
    dubbingAIDetail: "Vertaling en voice-over in meerdere talen.",
    intelligentCut: "Intelligente knip:",
    intelligentCutDetail: "Scheidt en herschikt segmenten automatisch.",
    lipSync: "Lipsynchronisatie:",
    lipSyncDetail: "Stem de lipbewegingen af op de nieuwe audio.",
    lipEnhance: "Lippen verbeteren:",
    lipEnhanceDetail: "Verbetert de nauwkeurigheid van lipbewegingen voor natuurlijker nasynchroniseren.",
    videoMerge: "Video samenvoegen:",
    videoMergeDetail: "Combineert meerdere verwerkte clips.",
    realTimeProcess: "Realtime verwerking:",
    realTimeProcessDetail: "Snelle bewerking en directe aanpassingen.",
    plansTitle: "Plannen en prijzen",
    choosePlan: "Kies het ideale plan voor jou:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB en 30s limiet. Eenmalige proef met advertenties en watermerk.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5GB/maand, 2 video's/dag (100MB), knip- en samenvoegtools.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20GB/maand, 5 video's/dag (500MB), stemklonen en lipsynchronisatie.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50GB/maand, 10 video's/dag (1GB), lippen verbeteren en prioritaire ondersteuning.",
    seeInAction: "Bekijk het in actie!",
    officialChannel: "Voor meer video's, bezoek ons officiële kanaal:",
    officialChannelLink: "Vision AI Stream op YouTube",
    faqTitle: "Veelgestelde vragen (FAQ)",
    faqQuestion1: "Is Vision AI Stream gratis?",
    faqAnswer1: "Ja, we bieden een eenmalige gratis proefversie aan. Betaalde plannen bieden meer functies.",
    faqQuestion2: "Welke videoformaten worden ondersteund?",
    faqAnswer2: "We ondersteunen populaire formaten zoals MP4, AVI en MOV.",
    faqQuestion3: "Kan ik nasynchronisatie met stemklonen gebruiken?",
    faqAnswer3: "Ja, vanaf het Growth-plan kun je stemklonen en lipsynchronisatie gebruiken.",
    userFeedbackTitle: "Gebruikersfeedback",
    userFeedbackDetail: "Vision AI Stream heeft een geïntegreerd feedbackformulier in de videoprocessing, zodat gebruikers direct suggesties kunnen doorgeven en problemen kunnen melden.",
    backHomeButton: "Probeer het nu 🚀",
    aboutCompanyTitle: "Over het bedrijf",
    companyDescription: "Vision AI Stream is ontwikkeld door QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA, gespecialiseerd in maatwerksoftware."
  },

  sv: {
    title: "Vad är Vision AI Stream?",
    description1: "Vision AI Stream är en avancerad videoredigeringsplattform baserad på artificiell intelligens...",
    mainFeaturesTitle: "Huvudfunktioner",
    transcription: "Automatisk transkribering:",
    transcriptionDetail: "Konverterar ljud till text med precision.",
    dubbingAI: "AI-dubbning:",
    dubbingAIDetail: "Översättning och berättarröst på flera språk.",
    intelligentCut: "Intelligent klippning:",
    intelligentCutDetail: "Delar upp och omorganiserar segment automatiskt.",
    lipSync: "Läppsynk:",
    lipSyncDetail: "Justerar läpprörelser till det nya ljudet.",
    lipEnhance: "Förbättrad läppsynk:",
    lipEnhanceDetail: "Förbättrar noggrannheten i läpprörelser för en mer naturlig dubbning.",
    videoMerge: "Videofusion:",
    videoMergeDetail: "Kombinerar flera bearbetade klipp.",
    realTimeProcess: "Bearbetning i realtid:",
    realTimeProcessDetail: "Snabba redigeringar och omedelbara justeringar.",
    plansTitle: "Planer och priser",
    choosePlan: "Välj den perfekta planen för dig:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB och 30s gräns. Engångstest med annonser och vattenstämpel.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5 GB/månad, 2 videor/dag (100 MB), verktyg för klippning och sammanslagning.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20 GB/månad, 5 videor/dag (500 MB), röstkloning och läppsynk.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50 GB/månad, 10 videor/dag (1 GB), förbättrad läppsynk och prioriterad support.",
    seeInAction: "Se den i aktion!",
    officialChannel: "För fler videor, besök vår officiella kanal:",
    officialChannelLink: "Vision AI Stream på YouTube",
    faqTitle: "Vanliga frågor (FAQ)",
    faqQuestion1: "Är Vision AI Stream gratis?",
    faqAnswer1: "Ja, vi erbjuder en engångs gratis provperiod. Betalda planer ger fler funktioner.",
    faqQuestion2: "Vilka videoformat stöds?",
    faqAnswer2: "Vi stöder populära format som MP4, AVI och MOV.",
    faqQuestion3: "Kan jag använda dubbning med röstkloning?",
    faqAnswer3: "Ja, från och med Growth-planen kan du använda röstkloning och läppsynk.",
    userFeedbackTitle: "Användarfeedback",
    userFeedbackDetail: "Vision AI Stream har ett integrerat feedbackformulär i videobearbetningen, så att användare kan skicka förslag och rapportera problem direkt.",
    backHomeButton: "Prova nu 🚀",
    aboutCompanyTitle: "Om företaget",
    companyDescription: "Vision AI Stream utvecklas av QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA, specialiserad på skräddarsydd programvaruutveckling."
  },

  no: {
    title: "Hva er Vision AI Stream?",
    description1: "Vision AI Stream er en avansert videoredigeringsplattform basert på kunstig intelligens...",
    mainFeaturesTitle: "Hovedfunksjoner",
    transcription: "Automatisk transkripsjon:",
    transcriptionDetail: "Konverterer lyd til tekst med presisjon.",
    dubbingAI: "KI-dubbing:",
    dubbingAIDetail: "Oversettelse og fortellerstemme på flere språk.",
    intelligentCut: "Intelligent klipp:",
    intelligentCutDetail: "Deler og omorganiserer segmenter automatisk.",
    lipSync: "Leppe-synk:",
    lipSyncDetail: "Justerer leppebevegelser til den nye lyden.",
    lipEnhance: "Forbedret leppebevegelse:",
    lipEnhanceDetail: "Forbedrer nøyaktigheten i leppebevegelser for en mer naturlig dubbing.",
    videoMerge: "Sammenslåing av videoer:",
    videoMergeDetail: "Kombinerer flere behandlede klipp.",
    realTimeProcess: "Realtidsbehandling:",
    realTimeProcessDetail: "Rask redigering og umiddelbare justeringer.",
    plansTitle: "Planer og Priser",
    choosePlan: "Velg den ideelle planen for deg:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB og 30s grense. Engangstest med annonser og vannmerke.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5 GB/måned, 2 videoer/dag (100 MB), verktøy for klipping og sammenslåing.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20 GB/måned, 5 videoer/dag (500 MB), stemmekloning og leppe-synk.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50 GB/måned, 10 videoer/dag (1 GB), forbedret leppebevegelse og prioritert støtte.",
    seeInAction: "Se det i aksjon!",
    officialChannel: "For flere videoer, besøk vår offisielle kanal:",
    officialChannelLink: "Vision AI Stream på YouTube",
    faqTitle: "Ofte stilte spørsmål (FAQ)",
    faqQuestion1: "Er Vision AI Stream gratis?",
    faqAnswer1: "Ja, vi tilbyr en engangs gratis prøveversjon. Betalte planer gir flere funksjoner.",
    faqQuestion2: "Hvilke videoformater støttes?",
    faqAnswer2: "Vi støtter populære formater som MP4, AVI og MOV.",
    faqQuestion3: "Kan jeg bruke dubbing med stemmekloning?",
    faqAnswer3: "Ja, fra Growth-planen kan du bruke stemmekloning og leppe-synk.",
    userFeedbackTitle: "Brukerfeedback",
    userFeedbackDetail: "Vision AI Stream har et integrert tilbakemeldingsskjema i videoprosesseringen, som lar brukerne sende inn forslag og rapportere problemer direkte.",
    backHomeButton: "Prøv nå 🚀",
    aboutCompanyTitle: "Om Selskapet",
    companyDescription: "Vision AI Stream er utviklet av QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA, spesialisert på tilpasset programvareutvikling."
  },

  pl: {
    title: "Czym jest Vision AI Stream?",
    description1: "Vision AI Stream to zaawansowana platforma do edycji wideo oparta na sztucznej inteligencji...",
    mainFeaturesTitle: "Główne funkcje",
    transcription: "Automatyczna transkrypcja:",
    transcriptionDetail: "Dokładnie przekształca dźwięk w tekst.",
    dubbingAI: "Dubbing z SI:",
    dubbingAIDetail: "Tłumaczenie i voice-over w wielu językach.",
    intelligentCut: "Inteligentne cięcie:",
    intelligentCutDetail: "Automatycznie dzieli i przeorganizowuje segmenty.",
    lipSync: "Synchronizacja ust:",
    lipSyncDetail: "Dostosowuje ruch ust do nowego dźwięku.",
    lipEnhance: "Poprawa ust:",
    lipEnhanceDetail: "Zwiększa precyzję ruchów warg, aby dubbing był bardziej naturalny.",
    videoMerge: "Scalanie wideo:",
    videoMergeDetail: "Łączy wiele przetworzonych klipów.",
    realTimeProcess: "Przetwarzanie w czasie rzeczywistym:",
    realTimeProcessDetail: "Szybka edycja i natychmiastowe dostosowania.",
    plansTitle: "Plany i ceny",
    choosePlan: "Wybierz idealny plan dla siebie:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB i 30s limit. Jednorazowy test z reklamami i znakiem wodnym.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5 GB/mies., 2 wideo/dzień (100 MB), narzędzia do cięcia i łączenia.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20 GB/mies., 5 wideo/dzień (500 MB), klonowanie głosu i synchronizacja ust.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50 GB/mies., 10 wideo/dzień (1 GB), poprawa ust i priorytetowe wsparcie.",
    seeInAction: "Zobacz to w akcji!",
    officialChannel: "Więcej filmów znajdziesz na naszym oficjalnym kanale:",
    officialChannelLink: "Vision AI Stream na YouTube",
    faqTitle: "Najczęściej zadawane pytania (FAQ)",
    faqQuestion1: "Czy Vision AI Stream jest darmowy?",
    faqAnswer1: "Tak, oferujemy jednorazowy darmowy okres próbny. Płatne plany oferują więcej funkcji.",
    faqQuestion2: "Jakie formaty wideo są obsługiwane?",
    faqAnswer2: "Obsługujemy popularne formaty takie jak MP4, AVI i MOV.",
    faqQuestion3: "Czy mogę używać dubbingu z klonowaniem głosu?",
    faqAnswer3: "Tak, od planu Growth możesz korzystać z klonowania głosu i synchronizacji ust.",
    userFeedbackTitle: "Opinie użytkowników",
    userFeedbackDetail: "Vision AI Stream posiada zintegrowany formularz opinii w trakcie przetwarzania wideo, umożliwiający użytkownikom bezpośrednie przesyłanie sugestii i zgłaszanie problemów.",
    backHomeButton: "Wypróbuj teraz 🚀",
    aboutCompanyTitle: "O Firmie",
    companyDescription: "Vision AI Stream został opracowany przez QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA, specjalizującą się w tworzeniu oprogramowania na zamówienie."
  },

  he: {
    title: "מהו Vision AI Stream?",
    description1: "Vision AI Stream היא פלטפורמה מתקדמת לעריכת וידאו המבוססת על בינה מלאכותית...",
    mainFeaturesTitle: "תכונות עיקריות",
    transcription: "תמלול אוטומטי:",
    transcriptionDetail: "ממירה קול לטקסט בדיוק רב.",
    dubbingAI: "דיבוב עם בינה מלאכותית:",
    dubbingAIDetail: "תרגום ודיבוב במספר שפות.",
    intelligentCut: "חיתוך חכם:",
    intelligentCutDetail: "מפצלת ומארגנת מחדש מקטעים באופן אוטומטי.",
    lipSync: "סנכרון שפתיים:",
    lipSyncDetail: "מתאימה את תנועות השפתיים לאודיו החדש.",
    lipEnhance: "העצמת שפתיים:",
    lipEnhanceDetail: "משפרת את הדיוק של תנועות השפתיים לקבלת דיבוב טבעי יותר.",
    videoMerge: "מיזוג וידאו:",
    videoMergeDetail: "ממזגת מספר קטעים שעובדו.",
    realTimeProcess: "עיבוד בזמן אמת:",
    realTimeProcessDetail: "עריכה מהירה והתאמות מיידיות.",
    plansTitle: "תוכניות ומחירים",
    choosePlan: "בחרו את התוכנית המתאימה לכם:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB ו-30 שניות מגבלה. ניסיון חד-פעמי עם פרסומות וסימן מים.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5 ג׳יגה/בחודש, 2 סרטונים ביום (100 מגהבייט), כלים לחיתוך ומיזוג.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20 ג׳יגה/בחודש, 5 סרטונים ביום (500 מגהבייט), שיבוט קול וסנכרון שפתיים.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50 ג׳יגה/בחודש, 10 סרטונים ביום (1 ג׳יגה), העצמת שפתיים ותמיכה בעדיפות גבוהה.",
    seeInAction: "ראו זאת בפעולה!",
    officialChannel: "למידע נוסף, בקרו בערוץ הרשמי שלנו:",
    officialChannelLink: "Vision AI Stream ב-YouTube",
    faqTitle: "שאלות נפוצות (FAQ)",
    faqQuestion1: "האם Vision AI Stream חינמי?",
    faqAnswer1: "כן, אנו מציעים ניסיון חינם חד-פעמי. התוכניות בתשלום מציעות יותר תכונות.",
    faqQuestion2: "אילו פורמטי וידאו נתמכים?",
    faqAnswer2: "אנו תומכים בפורמטים פופולריים כגון MP4, AVI ו-MOV.",
    faqQuestion3: "האם אפשר להשתמש בדיבוב עם שיבוט קול?",
    faqAnswer3: "כן, החל מתוכנית Growth ניתן להשתמש בשיבוט קול וסנכרון שפתיים.",
    userFeedbackTitle: "משוב משתמשים",
    userFeedbackDetail: "ב-Vision AI Stream יש טופס משוב משולב בעיבוד הווידאו, המאפשר למשתמשים לשלוח הצעות ולדווח על בעיות באופן ישיר.",
    backHomeButton: "נסו עכשיו 🚀",
    aboutCompanyTitle: "אודות החברה",
    companyDescription: "Vision AI Stream פותח על ידי QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA, המתמחה בפיתוח תוכנה מותאם אישית."
  },

  fi: {
    title: "Mikä on Vision AI Stream?",
    description1: "Vision AI Stream on kehittynyt tekoälyyn perustuva videoeditointialusta...",
    mainFeaturesTitle: "Tärkeimmät ominaisuudet",
    transcription: "Automaattinen transkriptio:",
    transcriptionDetail: "Muuntaa äänen tarkasti tekstiksi.",
    dubbingAI: "AI-jälkiäänitys:",
    dubbingAIDetail: "Käännökset ja äänet monilla kielillä.",
    intelligentCut: "Älykäs leikkaus:",
    intelligentCutDetail: "Jakaa ja järjestelee segmenttejä automaattisesti uudelleen.",
    lipSync: "Huulisynkronointi:",
    lipSyncDetail: "Mukauttaa huulten liikkeet uuteen ääneen.",
    lipEnhance: "Huulten parannus:",
    lipEnhanceDetail: "Parantaa huulten liikkeiden tarkkuutta luonnollisemman jälkiäänityksen aikaansaamiseksi.",
    videoMerge: "Videon yhdistäminen:",
    videoMergeDetail: "Yhdistää useita käsiteltyjä leikkeitä.",
    realTimeProcess: "Reaaliaikainen käsittely:",
    realTimeProcessDetail: "Nopeaa editointia ja välittömiä säätöjä.",
    plansTitle: "Paketit ja hinnat",
    choosePlan: "Valitse sinulle sopivin paketti:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB ja 30s raja. Kertakokeilu mainoksilla ja vesileimalla.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5 Gt/kk, 2 videota/päivä (100 Mt), leikkaus- ja yhdistystyökalut.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20 Gt/kk, 5 videota/päivä (500 Mt), äänen kloonaus ja huulisynkronointi.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50 Gt/kk, 10 videota/päivä (1 Gt), huulten parannus ja priorisoitu tuki.",
    seeInAction: "Katso toiminnassa!",
    officialChannel: "Lisää videoita löydät viralliselta kanavaltamme:",
    officialChannelLink: "Vision AI Stream YouTubessa",
    faqTitle: "Usein kysytyt kysymykset (FAQ)",
    faqQuestion1: "Onko Vision AI Stream ilmainen?",
    faqAnswer1: "Kyllä, tarjoamme kertaluontoisen ilmaisen kokeilun. Maksulliset suunnitelmat tarjoavat enemmän ominaisuuksia.",
    faqQuestion2: "Mitä videoformaatteja tuetaan?",
    faqAnswer2: "Tuemme suosittuja formaatteja, kuten MP4, AVI ja MOV.",
    faqQuestion3: "Voinko käyttää äänen kloonausta jälkiäänityksessä?",
    faqAnswer3: "Kyllä, Growth-paketista alkaen voit käyttää äänen kloonausta ja huulisynkronointia.",
    userFeedbackTitle: "Käyttäjäpalaute",
    userFeedbackDetail: "Vision AI Streamissa on integroitu palautelomake videonkäsittelyn aikana, jolloin käyttäjät voivat lähettää ehdotuksia ja raportoida ongelmista suoraan.",
    backHomeButton: "Kokeile nyt 🚀",
    aboutCompanyTitle: "Tietoa yrityksestä",
    companyDescription: "Vision AI Stream on QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA:n kehittämä, erikoistunut räätälöityyn ohjelmistokehitykseen."
  },

  el: {
    title: "Τι είναι το Vision AI Stream;",
    description1: "Το Vision AI Stream είναι μία προηγμένη πλατφόρμα επεξεργασίας βίντεο βασισμένη σε τεχνητή νοημοσύνη...",
    mainFeaturesTitle: "Κύρια Χαρακτηριστικά",
    transcription: "Αυτόματη Απομαγνητοφώνηση:",
    transcriptionDetail: "Μετατρέπει ήχο σε κείμενο με ακρίβεια.",
    dubbingAI: "Μεταγλώττιση με ΤΝ:",
    dubbingAIDetail: "Μετάφραση και αφήγηση σε πολλές γλώσσες.",
    intelligentCut: "Έξυπνη Κοπή:",
    intelligentCutDetail: "Χωρίζει και αναδιατάσσει αυτόματα τα τμήματα.",
    lipSync: "Συγχρονισμός Χειλιών:",
    lipSyncDetail: "Προσαρμόζει την κίνηση των χειλιών στο νέο ήχο.",
    lipEnhance: "Βελτίωση Χειλιών:",
    lipEnhanceDetail: "Βελτιώνει την ακρίβεια στην κίνηση των χειλιών για πιο φυσική μεταγλώττιση.",
    videoMerge: "Συγχώνευση Βίντεο:",
    videoMergeDetail: "Συνδυάζει πολλαπλά επεξεργασμένα κλιπ.",
    realTimeProcess: "Επεξεργασία σε Πραγματικό Χρόνο:",
    realTimeProcessDetail: "Γρήγορη επεξεργασία και άμεσες ρυθμίσεις.",
    plansTitle: "Πλάνα και Τιμές",
    choosePlan: "Επιλέξτε το ιδανικό πλάνο για εσάς:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB και 30s όριο. Μοναδική δοκιμή με διαφημίσεις και υδατογράφημα.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5GB/μήνα, 2 βίντεο/ημέρα (100MB), εργαλεία κοπής και συγχώνευσης.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20GB/μήνα, 5 βίντεο/ημέρα (500MB), κλωνοποίηση φωνής και συγχρονισμός χειλιών.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50GB/μήνα, 10 βίντεο/ημέρα (1GB), βελτίωση χειλιών και προτεραιότητα στην υποστήριξη.",
    seeInAction: "Δείτε το στην πράξη!",
    officialChannel: "Για περισσότερα βίντεο, επισκεφτείτε το επίσημο κανάλι μας:",
    officialChannelLink: "Vision AI Stream στο YouTube",
    faqTitle: "Συχνές Ερωτήσεις (FAQ)",
    faqQuestion1: "Είναι το Vision AI Stream δωρεάν;",
    faqAnswer1: "Ναι, προσφέρουμε μία δωρεάν δοκιμή. Τα επί πληρωμή πακέτα παρέχουν περισσότερες δυνατότητες.",
    faqQuestion2: "Ποια μορφή βίντεο υποστηρίζεται;",
    faqAnswer2: "Υποστηρίζουμε δημοφιλείς μορφές όπως MP4, AVI και MOV.",
    faqQuestion3: "Μπορώ να χρησιμοποιήσω μεταγλώττιση με κλωνοποίηση φωνής;",
    faqAnswer3: "Ναι, από το πλάνο Growth και έπειτα μπορείτε να χρησιμοποιήσετε κλωνοποίηση φωνής και συγχρονισμό χειλιών.",
    userFeedbackTitle: "Σχόλια Χρηστών",
    userFeedbackDetail: "Το Vision AI Stream διαθέτει ενσωματωμένη φόρμα σχολίων στη διαδικασία επεξεργασίας βίντεο, επιτρέποντας στους χρήστες να υποβάλλουν προτάσεις και να αναφέρουν προβλήματα απευθείας.",
    backHomeButton: "Δοκιμάστε το τώρα 🚀",
    aboutCompanyTitle: "Σχετικά με την Εταιρεία",
    companyDescription: "Το Vision AI Stream αναπτύχθηκε από την QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA, η οποία ειδικεύεται στην προσαρμοσμένη ανάπτυξη λογισμικού."
  },

  da: {
    title: "Hvad er Vision AI Stream?",
    description1: "Vision AI Stream er en avanceret videoredigeringsplatform baseret på kunstig intelligens...",
    mainFeaturesTitle: "Primære Funktioner",
    transcription: "Automatisk transskription:",
    transcriptionDetail: "Konverterer lyd til tekst med præcision.",
    dubbingAI: "AI-dubbing:",
    dubbingAIDetail: "Oversættelse og speak på flere sprog.",
    intelligentCut: "Intelligent klip:",
    intelligentCutDetail: "Opdeler og omorganiserer segmenter automatisk.",
    lipSync: "Læbesynkronisering:",
    lipSyncDetail: "Matcher læbernes bevægelser til den nye lyd.",
    lipEnhance: "Læbeforbedring:",
    lipEnhanceDetail: "Forbedrer nøjagtigheden af læbebevægelser for en mere naturlig dubbing.",
    videoMerge: "Sammenfletning af videoer:",
    videoMergeDetail: "Kombinerer flere behandlede klip.",
    realTimeProcess: "Behandling i realtid:",
    realTimeProcessDetail: "Hurtig redigering og øjeblikkelige justeringer.",
    plansTitle: "Planer og Priser",
    choosePlan: "Vælg den ideelle plan for dig:",
    visionFree: "Vision Free:",
    visionFreeDetail: "50MB og 30s grænse. Én prøve med annoncer og vandmærke.",
    visionStarter: "Vision Starter:",
    visionStarterDetail: "5GB/md, 2 videoer/dag (100MB), værktøjer til klip og fletning.",
    visionGrowth: "Vision Growth:",
    visionGrowthDetail: "20GB/md, 5 videoer/dag (500MB), stemmekloning og læbesynkronisering.",
    visionPremium: "Vision Premium:",
    visionPremiumDetail: "50GB/md, 10 videoer/dag (1GB), læbeforbedring og prioriteret support.",
    seeInAction: "Se den i aktion!",
    officialChannel: "For flere videoer, besøg vores officielle kanal:",
    officialChannelLink: "Vision AI Stream på YouTube",
    faqTitle: "Ofte stillede spørgsmål (FAQ)",
    faqQuestion1: "Er Vision AI Stream gratis?",
    faqAnswer1: "Ja, vi tilbyder en engangs gratis prøveperiode. Betalte planer giver flere funktioner.",
    faqQuestion2: "Hvilke videoformater understøttes?",
    faqAnswer2: "Vi understøtter populære formater som MP4, AVI og MOV.",
    faqQuestion3: "Kan jeg bruge dubbing med stemmekloning?",
    faqAnswer3: "Ja, fra Growth-planen kan du bruge stemmekloning og læbesynkronisering.",
    userFeedbackTitle: "Brugerfeedback",
    userFeedbackDetail: "Vision AI Stream har en integreret feedbackformular i videobehandlingen, så brugere kan indsende forslag og rapportere problemer direkte.",
    backHomeButton: "Prøv det nu 🚀",
    aboutCompanyTitle: "Om Virksomheden",
    companyDescription: "Vision AI Stream er udviklet af QUESADA CONSULTORIA E DESENVOLVIMENTO DE SISTEMAS LTDA, som er specialiseret i skræddersyet softwareudvikling."
  },
};

export default aboutTranslations;
